import React from "react";
import "./Service.scss";
import {NavLink} from "react-router-dom";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import intl from "react-intl-universal";

export function Service() {
    const lang = LOCALES_HELPER.getLan();

    return <>
        <section className="light-color rollover effect-zoe clearfix portfolio-mosaic mosaic5" style={{paddingTop:"50px"}}>
            <div className="container full">
                <div className="row">
                    <div className="col-md-12 text-center heading blue-color">
                        <h1><span>{lang === DEFAULT_LOCALE?"行业资讯":""}</span>Industry News</h1>
                    </div>
                </div>
            </div>
        </section>

        <header className="image-background image-11 no-padding dark-color">
            <div className="mask opacity-6">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-light text-center">
                            <div className="header-6-header-space"></div>
                            {/*<h1 className="large block">行业资讯</h1>*/}
                        </div>
                    </div>
                    <div className="row pb-medium cus-padding">
                        <div className="col-md-4 col-sm-6">
                            <article className="box-icon">
                                <NavLink to="/news">
                                    <i className="icon-glyph-341 x-large"></i>
                                    <h3>{intl.get('xwydt')}</h3>
                                    <p>{lang === DEFAULT_LOCALE?"News":""}</p>
                                </NavLink>
                            </article>
                        </div>

                        <div className="col-md-4 col-sm-6">
                            <article className="box-icon">
                                <NavLink to="/service/qa">
                                    <i className="icon-glyph-143 x-large"></i>
                                    <h3>{intl.get('cjwt')}</h3>
                                    <p>{lang === DEFAULT_LOCALE?"Comment":""}</p>
                                </NavLink>
                            </article>
                        </div>

                        <div className="col-md-4 col-sm-6">
                            <article className="box-icon">
                                <NavLink to="/service/case">
                                    <i className="icon-glyph-86 x-large"></i>
                                    <h3>{intl.get('cases')}</h3>
                                    <p>{lang === DEFAULT_LOCALE?"Cases":""}</p>
                                </NavLink>
                            </article>
                        </div>

                    </div>
                </div>
            </div>
        </header>
    </>
}
